import { useParams } from "@tanstack/react-router";
import { useState } from "react";
import { useSelector } from "react-redux";
import { exportExcel } from "@/excel";
import { useFilteredIds } from "@/hooks/useFilteredIds";
import { useTranslations } from "@/queries/useTranslations";
import type { IState } from "@/state";
import { buildExportData } from "@/translationFiltering";
import { type ILanguage, LANGUAGES } from "@/types";

function ExportModal() {
    const { version } = useParams({ from: "/$version" });
    const [lang, setlang] = useState<ILanguage>("en");
    const { data: translations } = useTranslations(version);
    const editsByContent = useSelector((state: IState) => state.edits[version]?.data);
    const { filtered } = useFilteredIds(version);
    const exportData =
        translations && filtered ? buildExportData({ translations, editsByContent, filtered, lang }) : {};

    const handleExport = () => {
        // Generate the Excel workbook as a Blob.
        const blob = exportExcel(exportData);
        // Create a URL for the blob.
        const url = URL.createObjectURL(blob);
        // Create a temporary anchor element to trigger the download.
        const a = document.createElement("a");
        a.href = url;
        a.download = `tm_content_${lang}.xlsx`; // File name with language tag
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // Revoke the URL once it's been used.
        URL.revokeObjectURL(url);
    };
    return (
        <div>
            <h2>Export all answer for {version} as xlsx</h2>
            <div>
                <label>
                    Select langauge to export:{" "}
                    <select value={lang} onChange={(e) => setlang(e.target.value as ILanguage)}>
                        {LANGUAGES.map((l) => (
                            <option key={l} value={l}>
                                {l}
                            </option>
                        ))}
                    </select>
                </label>
                <button type="button" onClick={handleExport}>
                    Download (xlsx)
                </button>
            </div>
        </div>
    );
}

export default ExportModal;
